import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getVehicleTypesOverview } from '../../../store/Slices/VehicleTypeSlice';
import Stats from '../../../components/Stats';
import { activeStatsIcon, lateStatsIcon, tripStatsIcon } from '../../../utils/svgs';

const VehicleTypeOverviewCards = () => {
    const dispatch = useDispatch();
    const { vehicleTypesOverview, vehicleTypesOverviewLoading } = useSelector((state) => state.vehicleTypes);

    useEffect(() => {
        dispatch(getVehicleTypesOverview());
    }, [dispatch]);

    const statsData = [
        {
            title: 'Total Vehicle Types',
            value: vehicleTypesOverview?.total || 0,
            text: 'Total number of vehicle types',
            icon: tripStatsIcon,
            className: 'total'
        },
        {
            title: 'Active',
            value: vehicleTypesOverview?.active || 0,
            text: 'Active vehicle types',
            icon: activeStatsIcon,
            className: 'completed'
        },
        {
            title: 'Inactive',
            value: vehicleTypesOverview?.inactive || 0,
            text: 'Inactive vehicle types',
            icon: lateStatsIcon,
            className: 'late'
        }
    ];

    if (vehicleTypesOverviewLoading && !vehicleTypesOverview) {
        return (
            <div className="stats_main_div skeleton-loader" style={{ height: '100px', marginBottom: '20px' }}>
                {/* Skeleton state */}
            </div>
        );
    }

    return (
        <Stats statsData={statsData} numberOfColumn={4} />
    );
};

export default VehicleTypeOverviewCards;
